module.exports = __webpack_public_path__ + "static/media/allsystems.ce9fa8f1.png";